import { styled } from '@/styled-system/jsx';

export const DotsContainer = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
  },
});

export const Dot = styled('div', {
  base: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    transitionProperty: 'background-color',
    transitionDuration: '0.3s',
    transitionTimingFunction: 'ease',
  },
  variants: {
    active: {
      true: {
        backgroundColor: 'hpxTeal500',
      },
      false: {
        backgroundColor: 'hpxGrey400',
      },
    },
  },
  defaultVariants: {
    active: false,
  },
});
